export default "__VITE_PUBLIC_ASSET__9258ba05__"